<template>
  <span class="audit-actions">
    <el-button size="mini" type="success" plain @click="$emit('audit', 'approved')">审核通过</el-button>
    <el-button size="mini" type="warning" plain @click="$emit('audit', 'hidden')">隐藏</el-button>
  </span>
</template>

<script>
export default {
  name: "AuditButton"
};
</script>
